import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

function PrivateRoute({ children }: { children: any }) {
  const { user } = useAuth();
  const location = useLocation();
  return user?.isLoggedIn ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ path: location.pathname }} />
  );
}

function AdminRoute({ children }: { children: any }) {
  const { user } = useAuth();
  const location = useLocation();
  return user?.isAdmin ? (
    children
  ) : (
    <Navigate to="/" replace state={{ path: location.pathname }} />
  );
}

function PublicRoute({ children }: { children: any }) {
  const { user } = useAuth();
  const location = useLocation();
  return user?.isLoggedIn ? (
    <Navigate to="/" replace state={{ path: location.pathname }} />
  ) : (
    children
  );
}

export { PrivateRoute, PublicRoute, AdminRoute };
